angular.module('impactx.cube').service('NewCubeService', NewCubeService);

NewCubeService.$inject = ['$mdDialog'];

/**
 * Service for configuring a cube
 * @param dataGen Data service
 * @constructor
 */
function NewCubeService($mdDialog) {

    /**
     * Open the new cube dialog
     * @param ev
     */
    this.open = function (ev) {
        $mdDialog.show({
            controller: "CubeConfigCtrl",
            controllerAs: "cubeConfigCtrl",
            templateUrl: './modules/cube/templates/newcube.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: true,
            disableParentScroll: false
        });

    };

}
